/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { HoldersContainer } from './container';
import { useNavigate } from 'react-router-dom';
import { routes } from '@/AppNavigator/services/config/routes.config';

export const HoldersPage = ({ navigation }: { navigation: any }) => {
  const navigate = useNavigate();
  return (
    <HoldersContainer
      onViewDetailClick={(item: any) => {
        navigate(`${routes?.HoldersDetail?.path}/?userid=${item}`, {
          state: { detail: item?.rowData },
        });
      }}
    />
  );
};
